import Campaign from "../views/campaigns/campaign";
import Donations from "../views/campaigns/donations";

import ListIcon from "../assets/icons/plans.svg";
import ListHoverIcon from "../assets/icons/plans-hover.svg";
import DonationsIcon from "../assets/icons/pay-order.svg";
import DonationsIconHover from "../assets/icons/pay-orderHover.svg";


const routes = [
    {
        id: "cm8a1",
        path: "/campaign",
        name: "Campanhas",
        icon: ListIcon,
        iconHover: ListHoverIcon,
        layout: "/campaigns",
        component: Campaign,
        redirect: false,
    },

    {
        id: "cm8a2",
        path: "/donations",
        name: "Doações",
        icon: DonationsIcon,
        iconHover: DonationsIconHover,
        layout: "/campaigns",
        component: Donations,
        redirect: false,
    },
]

export default routes;